/**
 * Versions of the published legal documents.
 *
 * TERMS_VERSION is submitted with every sign-up and stored against the account.
 * If a customer later disputes a clause, the record has to point at the exact
 * wording they were shown — so this constant and public/legal/terms-of-service.md
 * must be changed in the same commit, and never retrospectively.
 */
export const TERMS_VERSION = '2.0';
// 2.1 (2026-08-05): the platform stopped setting any cookie that needs consent,
// so section 9 was rewritten and the cookie banner removed.
// 2.2 (2026-08-05): section 9.2 now names the cookies the marketing website
// sets, once that site was changed to load its tags only after consent.
export const PRIVACY_VERSION = '2.2';
export const PROSPECT_NOTICE_VERSION = '1.0';

/** The date printed at the top of the most recently changed document above. */
export const LEGAL_LAST_UPDATED = '2026-08-05';

/**
 * Where the legal documents are published.
 *
 * Every one of them names mars.mediacle.com as the address its current version
 * is always at, and that site renders the same markdown as public/legal/.
 * Serving a second copy here only created two places to drift, so this app
 * publishes none of them: nginx.conf answers each path below with a 301, and
 * the removal form was moved across with the documents so there is one route
 * out of the directory rather than two that behave differently.
 *
 * The markdown under public/legal/ is kept: it is the source copied into the
 * marketing site repo, and the tests read it to hold the versions above honest.
 */
export const TERMS_URL = 'https://mars.mediacle.com/terms';
export const PRIVACY_URL = 'https://mars.mediacle.com/privacy';
export const PROSPECT_NOTICE_URL = 'https://mars.mediacle.com/prospect-data';
export const DATA_REMOVAL_URL = 'https://mars.mediacle.com/data-removal';
